export const EMAIL = "info@bu.gov.tl";
export const PHONE = "(+670)333 9077";
export const ADDRESS = "Rua 20 de Maio, nº43, Dili, Timor-Leste";